
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Forceurbaniaonrentinpune() {



    const cardData =
    {
        keyword: ' Force Urbania On Rent in Pune',
        heading: 'Skyline Cabs: Force Urbania On Rent in Pune',
        headingDescription: 'Skyline Cabs offers spacious and reliable Force Urbania on Rent in Pune, perfect for group travel, corporate outings, family trips, and long-distance journeys. Designed for comfort and equipped with modern features, the Force Urbania ensures a smooth and luxurious ride for up to 17 passengers. With experienced drivers, flexible rental plans, transparent pricing, and 24/7 customer support, Skyline Cabs guarantees a safe and hassle-free travel experience. Book your Force Urbania in Pune today and enjoy premium group travel with unmatched comfort.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    
    
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Pune to Shirdi Force Urbania on Rent",
      "description": "Skyline Cabs offers Force Urbania rentals for comfortable and spacious travel from Pune to Shirdi. Ideal for group pilgrimages, the Urbania ensures a smooth and luxurious journey with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Ashtavinayak Urbania Tour Package from Pune",
      "description": "Experience the spiritual Ashtavinayak Yatra with Skyline Cabs' Force Urbania tour package from Pune. Perfect for groups, our package covers all key temples in comfort and style, with experienced drivers and customizable itinerary options."
    },
    {
      "name": "Pune to Mahabaleshwar Urbania on Rent",
      "description": "Travel to Mahabaleshwar with Skyline Cabs' Force Urbania on rent. Enjoy the scenic journey in a premium mini bus perfect for families or large groups seeking a comfortable outstation getaway."
    },
    {
      "name": "Force Urbania Vans on Rent in Viman Nagar",
      "description": "Skyline Cabs provides Force Urbania vans for rent in Viman Nagar, Pune. Whether for corporate events, weddings, or outstation trips, our luxury mini buses offer a premium travel experience."
    },
    {
      "name": "Urbania on Rent in Pune",
      "description": "Book a Force Urbania for rent anywhere in Pune with Skyline Cabs. Enjoy high-capacity seating, modern amenities, and smooth rides tailored for large group travel."
    },
    {
      "name": "Bus Hire for Wedding in Pune",
      "description": "Skyline Cabs offers luxury mini buses like Force Urbania for wedding events in Pune. Transport your guests in style and comfort, with options for decoration and custom scheduling."
    },
    {
      "name": "Force Urbania on Rent in Pune for Corporate Events",
      "description": "Hire a Force Urbania with Skyline Cabs for your next corporate event in Pune. Perfect for team outings, airport transfers, or conferences, our buses ensure professional and punctual service."
    },
    {
      "name": "Force Urbania on Rent in Kothrud",
      "description": "Looking for Force Urbania in Kothrud? Skyline Cabs offers easy rental solutions for outstation trips, group travel, and special events with pickup and drop from Kothrud."
    },
    {
      "name": "Force Urbania for Rent in Pune",
      "description": "Skyline Cabs provides premium Force Urbania vehicles for rent across Pune. Choose us for clean, reliable mini buses perfect for tours, pilgrimages, weddings, and more."
    },
    {
      "name": "Force Urbania Per Km Rate",
      "description": "Our Force Urbania is available on a per km rental basis. Get transparent pricing with no hidden charges, ideal for long-distance and multi-day trips from Pune."
    },
    {
      "name": "Force Urbania Luxury Mini Bus on Rent",
      "description": "Experience luxury group travel with Skyline Cabs’ Force Urbania mini bus rental. Plush interiors, ample space, and top-notch safety features make it perfect for all travel needs."
    },
    {
      "name": "Urbania on Rent in Viman Nagar",
      "description": "Need a Force Urbania in Viman Nagar? Skyline Cabs offers well-maintained Urbania mini buses ideal for local tours and outstation journeys with seamless pickup from Viman Nagar."
    },
    {
      "name": "Urbania on Rent in Koregaon Park Pune",
      "description": "Rent a Force Urbania in Koregaon Park with Skyline Cabs. Great for group transfers, functions, and Pune Darshan tours, our services are reliable and professional."
    },
    {
      "name": "Urbania on Rent in Kharadi",
      "description": "Book your Urbania in Kharadi with Skyline Cabs for any event or tour. Our spacious vans offer excellent seating and air conditioning for a relaxed travel experience."
    },
    {
      "name": "Urbania on Rent in Hadapsar",
      "description": "Skyline Cabs offers Force Urbania rentals in Hadapsar, Pune. Whether you're planning an outstation trip or a city tour, our mini buses provide a reliable and safe option."
    },
    {
      "name": "Force Urbania on Rent in Kalyani Nagar",
      "description": "Get access to premium Force Urbania rentals from Kalyani Nagar. Skyline Cabs ensures timely pickups, courteous drivers, and a smooth booking process for all group travel."
    },
    {
      "name": "Urbania on Rent for Pune Darshan",
      "description": "Explore Pune in a group with Skyline Cabs' Urbania Darshan packages. Visit major attractions with a comfortable ride, professional driver, and customizable city tour routes."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Force Urbania on Rent", "Pune to Ashtavinayak Urbania Tour Package from Pune"],
    ["Pune to Mahabaleshwar Urbania on Rent", "Force Urbania Vans on Rent in Viman Nagar"],
    ["Urbania on Rent in Pune", "Bus Hire for Wedding in Pune"],
    ["Force Urbania on Rent in Pune for Corporate Events", "Force Urbania on Rent in Kothrud"],
    ["Force Urbania for Rent in Pune", "Force Urbania Per Km Rate"],
    ["Force Urbania Luxury Mini Bus on Rent", "Urbania on Rent in Viman Nagar"],
    ["Urbania on Rent in Koregaon Park Pune", "Urbania on Rent in Kharadi"],
    ["Urbania on Rent in Hadapsar", "Force Urbania on Rent in Kalyani Nagar"],
    ["Urbania on Rent for Pune Darshan", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Force Urbania Rental in Pune",
        "WhyChoosedescription": "Our Force Urbania rental service in Pune is designed for comfort, reliability, and performance. Ideal for group travel, outstation trips, and special events, we ensure a seamless and stress-free rental experience."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors",
        "WhyChoosedescription": "Force Urbania offers ample legroom, plush seating, and modern amenities to ensure your journey is luxurious and comfortable—perfect for families, friends, or corporate groups."
    },
    {
        "WhyChooseheading": "Ideal for Group Travel",
        "WhyChoosedescription": "With seating options ranging from 13 to 17 passengers, the Force Urbania is perfect for larger groups looking to travel together in style without compromising on space or comfort."
    },
    {
        "WhyChooseheading": "Experienced Chauffeurs for a Smooth Ride",
        "WhyChoosedescription": "Our professional drivers are trained and experienced in handling outstation and city drives. They ensure timely pickups, safe driving, and a smooth travel experience throughout your journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive rental rates for Force Urbania in Pune, with no hidden charges. Our transparent pricing policy ensures you get full value for your money."
    },
    {
        "WhyChooseheading": "Available for All Travel Needs",
        "WhyChoosedescription": "Whether it's a wedding, corporate event, pilgrimage, or weekend getaway, you can rent a Force Urbania in Pune for any occasion. Flexible rental durations are available to suit your needs."
    },
    {
        "WhyChooseheading": "Easy Booking & Instant Confirmation",
        "WhyChoosedescription": "Booking your Force Urbania is quick and convenient with our online platform or customer support. Get instant confirmations and real-time trip updates for your peace of mind."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Vehicles",
        "WhyChoosedescription": "We prioritize hygiene and safety. Every Force Urbania vehicle is sanitized thoroughly before each trip, and we follow strict safety protocols for a worry-free travel experience."
    }
]










    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Force Urbania in Pune with Skyline Cabs?',
            answer:
                'You can easily rent a Force Urbania in Pune by booking through our website, mobile app, or by calling our customer support. Just select Force Urbania as your preferred vehicle, enter your travel details, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What is Force Urbania, and why is it a good rental choice in Pune?',
            answer:
                'Force Urbania is a premium tempo-style vehicle that offers spacious interiors, modern design, air conditioning, and comfortable seating for up to 17 passengers. It’s ideal for group travel, tours, and corporate outings from Pune.',
        },
        {
            id: 3,
            question: 'Is Force Urbania available for both local and outstation trips in Pune?',
            answer:
                'Yes, you can rent Force Urbania for both local travel within Pune and long-distance outstation trips to destinations like Mumbai, Shirdi, Lonavala, and more.',
        },
        {
            id: 4,
            question: 'Are the fares for Force Urbania rentals in Pune fixed?',
            answer:
                'Yes, our pricing is fixed and transparent. The rental cost includes fuel, driver charges, tolls, and taxes. You’ll know the full price before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book Force Urbania for a one-way trip from Pune?',
            answer:
                'Yes, one-way trips are available with Force Urbania. Just enter your destination details while booking, and we’ll take care of the rest.',
        },
        {
            id: 6,
            question: 'Is Force Urbania suitable for corporate and event travel?',
            answer:
                'Absolutely! Force Urbania is perfect for corporate group travel, team outings, airport pickups, wedding events, and large family trips. It’s spacious and offers a comfortable experience.',
        },
        {
            id: 7,
            question: 'Are Force Urbania vehicles well-maintained and hygienic?',
            answer:
                'Yes, all our Force Urbania vehicles are regularly maintained, sanitized, and inspected for safety and comfort. We ensure a clean and pleasant ride for every trip.',
        },
        {
            id: 8,
            question: 'What payment options are available for Force Urbania rentals in Pune?',
            answer:
                'You can pay online via UPI, credit/debit cards, net banking, or in cash at the end of the ride. All transactions are secure and hassle-free.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Force Urbania booking?',
            answer:
                'Yes, Skyline Cabs offers flexible cancellation and modification options. You can update your booking easily through our app, website, or by calling customer support.',
        },
        {
            id: 10,
            question: 'Why should I rent a Force Urbania from Skyline Cabs in Pune?',
            answer:
                'Skyline Cabs offers reliable service, transparent pricing, and experienced drivers. Renting a Force Urbania with us means enjoying premium group travel in comfort, whether it’s a local trip or a long journey from Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "We rented a Force Urbania from Pune to Shirdi for a group trip. The ride was smooth, the vehicle was clean and spacious, and the driver was very cooperative. Excellent service!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Force Urbania was perfect for our wedding guest transfers in Pune. It was roomy, comfortable, and arrived on time. Highly recommend Skyline Cabs for group travel!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania on Rent in Pune",
  "image": "https://skylinecabs.com/assets/images/force-urbania-on-rent-pune.jpg",
  "description": "Rent Force Urbania in Pune with Skyline Cabs for group travel, tours, and corporate events. Spacious 13, 17, and 20 seater vans available with AC, pushback seats, and professional drivers — ideal for outstation trips and family tours.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "9112"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/force-urbania-on-rent-in-pune"
  }
};


      
      
      


    return (
        <div>
<Helmet>
  <title>Force Urbania on Rent in Pune | 13, 17, 20 Seater AC Vans | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Rent Force Urbania in Pune with Skyline Cabs for group travel, tours, and corporate events. Spacious 13, 17, and 20 seater vans available with AC, pushback seats, and professional drivers — ideal for outstation trips and family tours." 
  />
  <meta 
    name="keywords" 
    content="Force Urbania on Rent in Pune, Rent Urbania Van Pune, 13 Seater Urbania Pune, 17 Seater Force Urbania Pune, Urbania for School Trip Pune, Urbania Van Booking Pune, AC Urbania Van Pune, Group Travel Urbania Pune, Urbania for Outstation Pune, Skyline Cabs Urbania" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/76.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbaniaonrentinpune;